
import {serializable, alias, object, list, primitive} from 'serializr';


export class StudentPerformanceModel { 
	@serializable(alias('gradeId', primitive()))
	gradeId?: number;

	@serializable(alias('gradeName', primitive()))
	gradeName?: string;

	@serializable(alias('gradeStrength', primitive()))
	gradeStrength?: number;

	@serializable(alias('videoViewed', primitive()))
	videoViewed?: number;

	@serializable(alias('pdfViewed', primitive()))
	pdfViewed?: number;

	@serializable(alias('quickQuiz', primitive()))
	quickQuiz?: number;

	@serializable(alias('excercise', primitive()))
	excercise?: number;
}

export class datasetsModel { 
	@serializable(alias('ids', list(primitive())))
	ids?: any[];

	@serializable(alias('label', primitive()))
	label?: string;

	@serializable(alias('backgroundColor', primitive()))
	backgroundColor?: string;

	@serializable(alias('data', list(primitive())))
	data?: any[];
}

export class StudentPerformanceChartModel { 
	@serializable(alias('labels',list(primitive()) ))
	labels?: string[]=[];

	@serializable(alias('datasets', list(object(datasetsModel))))
	datasets?: datasetsModel[]=[];
}


export class StudentGradePerformanceModel { 
	@serializable(alias('sectionId', primitive()))
	sectionId?: number;

	@serializable(alias('sectionName', primitive()))
	sectionName?: string;

	@serializable(alias('sectionStrength', primitive()))
	sectionStrength?: number;

	@serializable(alias('videoViewed', primitive()))
	videoViewed?: number;

	@serializable(alias('pdfViewed', primitive()))
	pdfViewed?: number;

	@serializable(alias('quickQuiz', primitive()))
	quickQuiz?: number;

	@serializable(alias('excercise', primitive()))
	excercise?: number;
}







